import { LuClipboardPlus } from 'react-icons/lu';
import { Action, ActionProps } from '../action';
import { forwardRef } from 'react';

export const ClipboardPlus = forwardRef<HTMLButtonElement, ActionProps>(
  (props: ActionProps, ref) => {
    return (
      <Action {...props} ref={ref} Icon={LuClipboardPlus} variant="default" />
    );
  }
);
